export const wsChannels = {
  timeLine: 'TimelineChannel',
} as const;
